var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A9DA0E48-5B06-42C4-A565-1F18453C4104") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile-C",
    transform: "translate(-263.000000, -145.000000)",
    fill: "#191919",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-Info",
    transform: "translate(0.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_camera2",
    transform: "translate(261.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,20 L2,6 L7,6 L9,4 L15,4 L17,6 L22,6 L22,20 L2,20 Z M4,18 L20,18 L20,8 L16,8 L14,6 L10,6 L8,8 L4,8 L4,18 Z M12,17.5 C9.23857625,17.5 7,15.2614237 7,12.5 C7,9.73857625 9.23857625,7.5 12,7.5 C14.7614237,7.5 17,9.73857625 17,12.5 C17,15.2614237 14.7614237,17.5 12,17.5 Z M12,15.5 C13.6568542,15.5 15,14.1568542 15,12.5 C15,10.8431458 13.6568542,9.5 12,9.5 C10.3431458,9.5 9,10.8431458 9,12.5 C9,14.1568542 10.3431458,15.5 12,15.5 Z M4,4 L6,4 L6,5 L4,5 L4,4 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCamera);
export default __webpack_public_path__ + "static/media/ico_camera.778200225abbfb1abaaa7d1252203475.svg";
export { ForwardRef as ReactComponent };